/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatusEnum } from './StatusEnum';
import {
    StatusEnumFromJSON,
    StatusEnumFromJSONTyped,
    StatusEnumToJSON,
    StatusEnumToJSONTyped,
} from './StatusEnum';

/**
 * 
 * @export
 * @interface ProsecutionUpdate
 */
export interface ProsecutionUpdate {
    /**
     * 
     * @type {string}
     * @memberof ProsecutionUpdate
     */
    title?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProsecutionUpdate
     */
    caseNumbers?: Array<string> | null;
    /**
     * 
     * @type {Date}
     * @memberof ProsecutionUpdate
     */
    filingDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ProsecutionUpdate
     */
    resolutionDate?: Date | null;
    /**
     * 
     * @type {StatusEnum}
     * @memberof ProsecutionUpdate
     */
    status?: StatusEnum | null;
    /**
     * 
     * @type {number}
     * @memberof ProsecutionUpdate
     */
    settlementAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProsecutionUpdate
     */
    judgmentAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProsecutionUpdate
     */
    summary?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProsecutionUpdate
     */
    detailedDescription?: string | null;
}



/**
 * Check if a given object implements the ProsecutionUpdate interface.
 */
export function instanceOfProsecutionUpdate(value: object): value is ProsecutionUpdate {
    return true;
}

export function ProsecutionUpdateFromJSON(json: any): ProsecutionUpdate {
    return ProsecutionUpdateFromJSONTyped(json, false);
}

export function ProsecutionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProsecutionUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'caseNumbers': json['case_numbers'] == null ? undefined : json['case_numbers'],
        'filingDate': json['filing_date'] == null ? undefined : (new Date(json['filing_date'])),
        'resolutionDate': json['resolution_date'] == null ? undefined : (new Date(json['resolution_date'])),
        'status': json['status'] == null ? undefined : StatusEnumFromJSON(json['status']),
        'settlementAmount': json['settlement_amount'] == null ? undefined : json['settlement_amount'],
        'judgmentAmount': json['judgment_amount'] == null ? undefined : json['judgment_amount'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'detailedDescription': json['detailed_description'] == null ? undefined : json['detailed_description'],
    };
}

export function ProsecutionUpdateToJSON(json: any): ProsecutionUpdate {
    return ProsecutionUpdateToJSONTyped(json, false);
}

export function ProsecutionUpdateToJSONTyped(value?: ProsecutionUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'case_numbers': value['caseNumbers'],
        'filing_date': value['filingDate'] == null ? undefined : ((value['filingDate'] as any).toISOString().substring(0,10)),
        'resolution_date': value['resolutionDate'] == null ? undefined : ((value['resolutionDate'] as any).toISOString().substring(0,10)),
        'status': StatusEnumToJSON(value['status']),
        'settlement_amount': value['settlementAmount'],
        'judgment_amount': value['judgmentAmount'],
        'summary': value['summary'],
        'detailed_description': value['detailedDescription'],
    };
}

